import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME_REFERENCE_BOOK } from '@/features/constants';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { AccuracyClass, AccuracyClassRequestBody } from './types';

export const meterAccuracyClassesApi = createApi({
  reducerPath: 'meterAccuracyClassesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/accuracy-classes`,
  }),
  tagTypes: ['AccuracyClass', 'AccuracyClasses'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME_REFERENCE_BOOK,
  endpoints: builder => ({
    getAccuracyClasses: builder.query<AccuracyClass[], void>({
      query: () => ({
        url: '/',
      }),
      providesTags: () => ['AccuracyClass', 'AccuracyClasses'],
    }),
    getAccuracyClassById: builder.query<AccuracyClass, string>({
      query: id => ({
        url: `/${id}`,
      }),
      providesTags: () => ['AccuracyClass'],
    }),
    createAccuracyClass: builder.mutation<
      AccuracyClass,
      AccuracyClassRequestBody
    >({
      query: data => ({
        url: '/',
        method: 'POST',
        data,
      }),
      invalidatesTags: result => [
        'AccuracyClass',
        { type: 'AccuracyClass', id: result?.id },
      ],
    }),
    updateAccuracyClass: builder.mutation<
      AccuracyClass,
      AccuracyClassRequestBody
    >({
      query: data => ({
        url: `/${data.id}`,
        method: 'PUT',
        data,
      }),
      invalidatesTags: result => [
        'AccuracyClass',
        { type: 'AccuracyClass', id: result?.id },
      ],
    }),
    deleteAccuracyClassById: builder.mutation<void, string>({
      query: id => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (_, __, id) => [
        'AccuracyClass',
        { type: 'AccuracyClass', id },
      ],
    }),
  }),
});

export const { useGetAccuracyClassesQuery } = meterAccuracyClassesApi;
